import Vue from 'vue'

export default {

    getListLandings(params){
        return Vue.axios.get(`/seo-tag-landings`, {params})
    },
    getLanding(id){
        return Vue.axios.get(`/seo-tag-landings/${id}`)
    },
    updateLanding(id, params){
        return Vue.axios.post(`/seo-tag-landings/update/${id}`, params)
    },
    create(params){
        return Vue.axios.post(`/seo-tag-landings/create`, params)
    },
    delete(params){
        return Vue.axios.post(`/seo-tag-landings/delete`, params)
    },

    updateProducts(params) {
        return Vue.axios.post(`/seo-tag-landings/update-products`, params)
    },
    removeProduct(id) {
        return Vue.axios.get(`/seo-tag-landings/remove-products/${id}`)
    },

    // create() {
    //     return Vue.aiox.post('/api/posts')
    // }
    // // etc
}
